module.exports = __webpack_public_path__ + "img/charging-dollar.c7440c2f.svg";